import { useTranslation } from 'react-i18next';

export default function WhatIs() {
  const { t } = useTranslation();

  return (
    <section className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20 lg:px-8">
        <div className="mx-auto max-w-3xl">
          <h2 className="text-center font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
            {t('home.whatTitle')}
          </h2>
          <div className="mt-8 space-y-5 text-base leading-relaxed text-foreground-700">
            <p>{t('home.whatP1')}</p>
            <p>{t('home.whatP2')}</p>
            <p>{t('home.whatP3')}</p>
          </div>

          <div className="mt-8 rounded-lg border border-accent-200 bg-accent-50 p-5">
            <div className="flex items-start gap-3">
              <span className="mt-0.5 flex h-6 w-6 items-center justify-center text-accent-600">
                <i className="ri-information-line text-xl"></i>
              </span>
              <div>
                <p className="text-sm font-semibold text-foreground-950">{t('home.whatNotice')}</p>
                <p className="mt-1 text-sm leading-relaxed text-foreground-700">{t('home.whatNoticeText')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}